import { MessageReactionsController } from './message-reactions.controller'

function messageReactions () {
  return {
    restrict: 'E',
    scope: {
      reactions: '=',
      selectedReaction: '=',
      onReact: '&',
      darkMode: '<',
      isAuthor: '<'
    },
    templateUrl: '/core/directives/message-reactions/message-reactions.html?$$REVISION$$',
    controller: MessageReactionsController
  }
}

export { messageReactions }
